<script>
import moment from "moment";

export default {
  name: "CertificadosDigitais",
  props: {
    certificados: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showAdicionarModal: false,
      showExcluirModal: false,
      certificadoExcluir: null
    }
  },
  filters: {
    date(value) {
      // Faz parte da data e retorna em GMT-3
      return moment(value).format('DD/MM/YYYY');
    }
  },
  methods: {
    abrirExcluirModal(certificado) {
      this.certificadoExcluir = certificado;
      this.showExcluirModal = true;
    },
    fecharExcluirModal() {
      this.showExcluirModal = false;
    },
    abrirAdicionarModal() {
      this.showAdicionarModal = true;
    },
    fecharAdicionarModal() {
      this.showAdicionarModal = false;
    }
  }
}
</script>

<template>
  <div>
    <div class="separate-section" style="display: flex; justify-content: space-between">
      <div class="col-md-6">
        <h3>Certificados Digitais</h3>
      </div>
      <div>
        <button class="btn -right" type="button" @click="abrirAdicionarModal">
          <b>ADICIONAR CERTIFICADO</b>
        </button>
      </div>
    </div>

    <div class="container" style="margin-top: 25px">
      <p>
        Você pode registrar seus certificados digitais da OAB para
        utilizá-los na visualização de autos.
      </p>

      <div class="col-md-12">
        <table class="Table table">
          <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>CPF</th>
            <th>Data de cadastro</th>
            <th>Data de expiração</th>
          </tr>
          </thead>
          <tbody v-if="certificados?.length">
          <tr v-for="certificado in certificados">
            <td>{{ certificado['id'] }}</td>
            <td>{{ certificado['pessoa_nome'] }}</td>
            <td>{{ certificado['pessoa_cpf'] }}</td>
            <td>{{ certificado['created_at'] | date }}</td>
            <td>{{ certificado['data_expiracao'] | date }}</td>
            <td>
              <button
                class="btn danger-background"
                type="button"
                @click="abrirExcluirModal(certificado)"
              >
                <b>Remover</b>
              </button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="9" style="text-align: center">
                Você ainda não registrou nenhum certificado digital da OAB.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <adicionar-certificado-digital-modal
      :visible="showAdicionarModal"
      @closeModal="fecharAdicionarModal"
    />
    <excluir-certificado-digital-modal
      :visible="showExcluirModal"
      :certificado="certificadoExcluir"
      @closeModal="fecharExcluirModal"
    />

  </div>
</template>

<style scoped lang="stylus">

</style>
